import React, { useContext } from 'react'
import { AffiliationsStyles } from './Style'
import { Table, Tabs } from 'components'
import { AffiliationsContext } from './AffiliationsContext'
import { affiliationsHooks } from '.'
import { isEmpty } from 'lodash'
import { LightButton, TablePageStyles, WrapHeader } from 'styles/GlobalStyle'
import { WrapDataGrid } from 'components/DataGrid/Style';
import { dataGridModel } from 'keys'

const Affiliations = () => {
    const { affiliationGroups, setGroupTab, groupTab, rowOpen, setRowOpen, affiliations, page, setPage, pageSize, setPageSize, searchVal, setSearchVal, sorting, affiliationsOptions, setSorting } = useContext(AffiliationsContext)
    const columns = affiliationsHooks.useTableColumns()
    const headerBtns = affiliationsHooks.useHeaderBtns()

    return (
        <AffiliationsStyles>
            <WrapHeader withTabs>
                {affiliationGroups?.length &&
                    <Tabs
                        labelKey="name"
                        tabs={affiliationGroups}
                        defaultTab={groupTab}
                        handleTab={setGroupTab}
                    />
                }
                <div className='header-btns'>
                    {headerBtns.map((btn, index) =>
                        <LightButton
                            {...btn}
                            key={index}
                            variant="solid"
                        />)}
                </div>
            </WrapHeader>
            <TablePageStyles hideSpace>
                <Table
                    withTitle
                    loading={affiliations.isFetching || isEmpty(affiliations.data)}
                    data={affiliations.data}
                    columns={columns}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    rowOpen={rowOpen}
                    setRowOpen={setRowOpen}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    sorting={sorting}
                    setSorting={setSorting}
                    queryKey={affiliationsOptions.queryKey}
                    visibilityModelKey={dataGridModel.affiliations}
                />
            </TablePageStyles>
        </AffiliationsStyles>
    )
}

export default Affiliations